<template>
    <form @submit="persistSection">

        <fieldset class="form-group form-control">
            <div class="row">
                <div class="col-sm-6">
                    <b-form-checkbox id="validationChroniqueur"
                                     v-model="sectionDatas.validationChroniqueur.datas" value="true"
                                     unchecked-value="false">
                        Validation chroniqueur
                    </b-form-checkbox>
                </div>
                <div class="col-sm-6">
                    <b-form-checkbox id="annulationForce"
                                     v-model="sectionDatas.annulationForce.datas" value="true"
                                     unchecked-value="false">
                        Forcer annulation du sujet
                    </b-form-checkbox>
                </div>
            </div>
        </fieldset>

        <intervenant v-for="(intervenant, index) in sectionDatas.intervenants.datas"
                     :intervenantId="intervenant.id" :key="intervenant.index"
                     :index="index" v-on:delete-me="removeIntervenant(intervenant.id, index)"
                     v-on:update-intervenant="updateIntervenant"
                     class="border"></intervenant>

        <div>
            <span class="btn" v-on:click="addIntervenant">Ajouter un intervenant</span>
        </div>

        <button type="submit" class="btn btn-primary mt-4" v-bind:disabled="editPending">Valider cette étape</button>
    </form>
</template>

<script>

  import intervenant from './Intervenant'
  import bdd from '../../api/bdd'

  export default {

    name: 'BookingForm',

    components: {
      intervenant
    },

    props: {
      subject: Object,
      editPending: false
    },

    data() {
      return {
        intervenantIndex: 0,
        sectionName: 'booking',
        sectionDatas: {
          intervenants: {
            name: 'intervenants',
            datas: [],
            trelloDatas: ''
          },
          validationChroniqueur: {
            name: 'validationChroniqueur',
            datas: ''
          },
          annulationForce: {
            name: 'annulationForce',
            datas: ''
          }
        },
        trelloDatasForIntervenants: {},
        intervenantsInvites: {}
      }
    },

    mounted() {
      for (let i = 0; i < this.subject.intervenants.length; i++) {
        this.sectionDatas.intervenants.datas.push({
          index: this.intervenantIndex++,
          id: this.subject.intervenants[i]
        })
      }
      this.sectionDatas.validationChroniqueur.datas = this.subject.validationChroniqueur
      this.sectionDatas.annulationForce.datas = this.subject.annulationForce
      this.$emit('push-section', this.sectionDatas, this.sectionName)
    },

    methods: {
      addIntervenant: function () {
        bdd.addIntervenant(this.subject.id)
          .then(intervenantId => {
            this.sectionDatas.intervenants.datas.push({
              index: this.intervenantIndex++,
              id: intervenantId
            })
            console.log('ajout intervenant', intervenantId)
          })
      },
      removeIntervenant: function (intervenantId, index) {
        bdd.deleteIntervenant(intervenantId)
          .then(response => {
            this.sectionDatas.intervenants.datas.splice(index, 1)
            console.log('suppression intervenant', intervenantId, response)
            // une fois un intervenant supprimé de la bdd on doit aussi supprimer sa description Trello associée
            delete this.trelloDatasForIntervenants[intervenantId]
            // et sa nature
            delete this.intervenantsInvites[intervenantId]
          })
      },
      updateIntervenant: function (intervenant, intervenantId, contact) {
        // on stocke la nature de l'intervenant
        this.intervenantsInvites[intervenantId] = intervenant.aInviter
        // on prépare sa description
        let trelloDatas = '**' + contact.fullName + '** \x0A \x0A '
        if (intervenant.type !== '') {
          trelloDatas += '- ' + intervenant.type + ' \x0A '
        }
        if (intervenant.statut !== '' && intervenant.statut !== undefined) {
          trelloDatas += '- ' + intervenant.statut + ' \x0A '
        } else {
          trelloDatas += '- en attente de contact \x0A '
        }
        if (contact.phone !== '' && contact.phone !== undefined) {
          trelloDatas += '- ' + contact.phone + ' \x0A '
        }
        if (contact.email !== '' && contact.email !== undefined) {
          trelloDatas += '- ' + contact.email + ' \x0A '
        }
        if (contact.fonction !== '' && contact.fonction !== undefined) {
          trelloDatas += '- ' + contact.fonction + ' \x0A '
        }
        trelloDatas += ' \x0A \x0A '
        this.trelloDatasForIntervenants[intervenantId] = trelloDatas
        // on update la description des intervenants
        // et on pousse la section pour la transmettre au composant parent
        // au fur et à mesure que l'on récupère intervenants
        this.prepareIntervenantsDatas()
        this.$emit('push-section', this.sectionDatas, this.sectionName)
      },
      persistSection: function (e) {
        e.preventDefault()
        // on update d'abord la description des intervenants car certains ont pu être supprimés
        this.prepareIntervenantsDatas()
        // et on envoie la mise à jour au composant parent
        this.$emit('push-edit', this.sectionDatas, this.sectionName)
      },
      prepareIntervenantsDatas: function () {
        this.sectionDatas.intervenants.trelloDatas = ''
        let infosInvites = ''
        let infosBooking = ''
        for (let intervenant in this.trelloDatasForIntervenants) {
          // en fonction de la nature de l'intervenant on l'intègre dans la section d'info correspondante
          if (this.intervenantsInvites[intervenant] === 'true') {
            infosInvites += this.trelloDatasForIntervenants[intervenant]
          } else {
            infosBooking += this.trelloDatasForIntervenants[intervenant]
          }
        }
        // en têtes de sections si données présentes
        if (infosBooking !== '') {
          infosBooking = '--\x0A###contacts booking : \x0A \x0A' + infosBooking
        }
        if (infosInvites !== '') {
          infosInvites = '--\x0A###invités : \x0A \x0A' + infosInvites
        }
        // la description finale
        this.sectionDatas.intervenants.trelloDatas = infosInvites + infosBooking
      }
    }

  }

</script>


// WEBPACK FOOTER //
// src/components/EditSub/BookingForm.vue